(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uv-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uv-bundle')) {
    customElements.define(
      'uv-bundle',
      class UvBundle extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-bundle-add]');
          this.items = Array.from(this.querySelectorAll('[data-bundle-item]')).map((element) => {
            const data = JSON.parse(element.querySelector('[data-bundle-item-json]').textContent);
            const tierTable =
              data.tierTable && typeof data.tierTable === 'object' && !Array.isArray(data.tierTable)
                ? Object.fromEntries(Object.entries(data.tierTable).map(([key, value]) => [key.toLowerCase(), value]))
                : null;
            return {
              ...data,
              tierTable,
              element,
              input: element.querySelector('[data-bundle-check]'),
              variant: data.variants.find((variant) => variant.id === data.variantId) || data.variants[0],
            };
          });

          this.addEventListener('change', (event) => {
            if (event.target.matches('[data-bundle-check]')) this.update();
          });
          this.button.addEventListener('click', () => this.addToCart());

          this.onVariantChange = (event) => this.matchVariant(event.detail);
          document.addEventListener('harmony:variant-change', this.onVariantChange);

          this.update();
        }

        disconnectedCallback() {
          document.removeEventListener('harmony:variant-change', this.onVariantChange);
        }

        matchVariant({ productId, variantId, options }) {
          const [current, ...added] = this.items;
          if (!current || current.productId !== productId) return;

          current.variant = current.variants.find((variant) => variant.id === variantId) || current.variant;
          added.forEach((item) => {
            item.variant =
              item.variants.find((v) => v.available && v.options.join('||') === options.join('||')) ||
              item.variants.find((v) => v.available && v.options[0] === options[0]) ||
              item.variants.find((v) => v.available) ||
              item.variant;
          });
          this.update();
        }

        // Matches the Harmony Discounts checkout rules. The tier item is discounted by
        // the number of icons; the full set gives every icon its own discount; any other
        // bundle with 2+ icons gives the 2-icon discount to the first icon only.
        bundlePrices(selection) {
          const prices = new Map(selection.map((item) => [item, item.variant.price]));
          if (selection.length < 2) return prices;

          const rate = Number(window.Shopify?.currency?.rate) || 1;
          const icons = selection.filter((item) => !item.tierTable);
          const tierItems = selection.filter((item) => item.tierTable);
          const goldLeafs = this.goldLeafs(icons);
          const takeOff = (item, cents) =>
            prices.set(item, Math.max(item.variant.price - Math.round(cents), 0));

          if (this.isFullSet(icons.length, tierItems, goldLeafs)) {
            icons.forEach((item) => {
              const { price, percentOff, amountOff } = item.variant;
              if (percentOff > 0) takeOff(item, (price * Math.min(percentOff, 100)) / 100);
              else if (amountOff > 0) takeOff(item, amountOff * rate * 100);
            });
          } else if (icons.length >= 2 && icons[0].variant.pairOff > 0) {
            takeOff(icons[0], icons[0].variant.pairOff * rate * 100);
          }
          tierItems.forEach((item) =>
            takeOff(item, this.tierAmount(item.tierTable, icons.length, goldLeafs) * rate * 100)
          );
          return prices;
        }

        goldLeafs(icons) {
          return [...new Set(icons.map((item) => item.variant.title.toLowerCase()))];
        }

        tierLists(table, goldLeafs) {
          return (goldLeafs.length ? goldLeafs : ['default']).map((goldLeaf) => {
            const tiers = Array.isArray(table[goldLeaf]) ? table[goldLeaf] : table.default;
            return Array.isArray(tiers) ? tiers : [];
          });
        }

        // Entry N-1 applies when N icons are in the bundle; mixed gold leafs use the smallest.
        tierAmount(table, count, goldLeafs) {
          if (count < 1) return 0;
          const amounts = this.tierLists(table, goldLeafs).map((tiers) =>
            tiers.length ? Number(tiers[Math.min(count, tiers.length) - 1]) || 0 : 0
          );
          return Math.min(...amounts);
        }

        // A tier table's length is the number of icons in the full set.
        isFullSet(iconCount, tierItems, goldLeafs) {
          return tierItems.some((item) => {
            const size = Math.max(...this.tierLists(item.tierTable, goldLeafs).map((tiers) => tiers.length));
            return size > 0 && iconCount >= size;
          });
        }

        // The selection after checking `added`, including a tier item it would lock on.
        withForcedItems(added) {
          const icons = this.items.filter((item) => !item.tierTable && (item === added || item.input.checked));
          const goldLeafs = this.goldLeafs(icons);
          return this.items.filter(
            (item) =>
              item === added ||
              item.input.checked ||
              (item.tierTable && item.variant.available && this.isFullSet(icons.length, [item], goldLeafs))
          );
        }

        update() {
          this.items.forEach((item) => {
            const available = item.variant.available;
            item.element.classList.toggle('uv-bundle__item--unavailable', !available);
            if (!available) item.input.checked = false;
            if (item.locked && available) item.input.checked = true;
          });

          // Every icon checked keeps the tier item (Lampada Kit) checked and locked.
          const checkedIcons = this.items.filter((item) => !item.tierTable && item.input.checked);
          const checkedGoldLeafs = this.goldLeafs(checkedIcons);
          this.items.forEach((item) => {
            const available = item.variant.available;
            const forced =
              Boolean(item.tierTable) && available && this.isFullSet(checkedIcons.length, [item], checkedGoldLeafs);
            if (forced) item.input.checked = true;
            item.input.disabled = item.locked || !available || forced;
          });

          const selected = this.items.filter((item) => item.input.checked);
          const prices = this.bundlePrices(selected);
          let total = 0;
          let compareTotal = 0;
          let tierSavings = 0;
          let tierItem = null;

          this.items.forEach((item) => {
            const price = item.variant.price;
            // Unchecked items show what they would cost once checked.
            const bundlePrice = item.input.checked
              ? prices.get(item)
              : this.bundlePrices(this.withForcedItems(item)).get(item);
            const discounted = bundlePrice < price;
            const shownPrice = item.tierTable ? bundlePrice : price;

            item.element.querySelector('[data-bundle-price]').textContent =
              shownPrice === 0 && this.dataset.freeLabel ? this.dataset.freeLabel : this.formatMoney(shownPrice);
            const compare = item.element.querySelector('[data-bundle-compare]');
            compare.textContent = this.formatMoney(price);
            compare.hidden = shownPrice >= price;

            const subtitle = item.element.querySelector('[data-bundle-subtitle]');
            const variantLabel = item.showVariant && item.variants.length > 1 ? item.variant.title : '';
            subtitle.textContent = [subtitle.dataset.base, variantLabel].filter(Boolean).join(' | ');

            const image = item.element.querySelector('[data-bundle-image]');
            if (image && item.variant.image && !image.src.startsWith(item.variant.image.split('?')[0])) {
              image.removeAttribute('srcset');
              image.src = item.variant.image;
            }

            if (item.input.checked) {
              total += bundlePrice;
              compareTotal += price;
              if (item.tierTable && discounted) {
                tierSavings += price - bundlePrice;
                tierItem = tierItem || { name: item.name, free: bundlePrice === 0 };
              }
            }
          });

          const savings = compareTotal - total;
          const savingsElement = this.querySelector('[data-bundle-savings]');
          if (savingsElement) {
            // [percent] is the discount on the one discounted icon, rounded down.
            const isIconPair = selected.length === 2 && selected.every((item) => !item.tierTable);
            const text =
              isIconPair && savings > 0
                ? this.dataset.percentSavingsText.replace(
                    '[percent]',
                    Math.floor((savings / selected[0].variant.price) * 100)
                  )
                : this.savingsText(savings, tierSavings, tierItem);
            savingsElement.textContent = text;
            savingsElement.hidden = !text;
          }

          const [current] = this.items;
          const canAdd = current && current.variant.available;
          this.button.disabled = !canAdd;
          this.querySelector('[data-bundle-label]').textContent = canAdd
            ? `${this.dataset.addLabel} — ${this.formatMoney(total)}`
            : this.dataset.soldOut;
          const totalCompare = this.querySelector('[data-bundle-total-compare]');
          totalCompare.textContent = this.formatMoney(compareTotal);
          totalCompare.hidden = !canAdd || savings <= 0;
        }

        savingsText(savings, tierSavings, tierItem) {
          if (tierItem && this.hasAttribute('data-detailed-savings')) {
            let text = tierItem.free
              ? this.dataset.freeItemText.replace('[item]', tierItem.name)
              : this.dataset.discountedItemText
                  .replace('[item]', tierItem.name)
                  .replace('[amount]', this.formatMoney(tierSavings));
            const iconSavings = savings - tierSavings;
            if (iconSavings > 0) {
              text += ` ${this.dataset.iconSavingsText.replace('[amount]', this.formatMoney(iconSavings))}`;
            }
            return text;
          }
          return savings > 0 ? `${this.dataset.savingsLabel} ${this.formatMoney(savings)}` : '';
        }

        formatMoney(cents) {
          const format = this.dataset.moneyFormat;
          if (!format) return (cents / 100).toFixed(2);
          const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
          const placeholder = match ? match[1] : 'amount';
          const withDelimiters = (decimals, thousands, decimal) => {
            const [whole, fraction] = (cents / 100).toFixed(decimals).split('.');
            const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
            return fraction && Number(fraction) !== 0 ? `${grouped}${decimal}${fraction}` : grouped;
          };
          const formatters = {
            amount: () => withDelimiters(2, ',', '.'),
            amount_no_decimals: () => withDelimiters(0, ',', '.'),
            amount_with_comma_separator: () => withDelimiters(2, '.', ','),
            amount_no_decimals_with_comma_separator: () => withDelimiters(0, '.', ','),
            amount_with_apostrophe_separator: () => withDelimiters(2, "'", '.'),
            amount_with_space_separator: () => withDelimiters(2, ' ', ','),
          };
          const value = (formatters[placeholder] || formatters.amount)();
          return format.replace(/\{\{\s*\w+\s*\}\}/, value);
        }

        async addToCart() {
          const selected = this.items.filter((item) => item.input.checked && item.variant.available);
          if (!selected.length) return;

          const bundleId = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}`;
          const lead = selected.find((item) => !item.tierTable);
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const body = {
            items: selected.map((item) => {
              const properties =
                selected.length > 1 ? { _harmony_bundle: item === lead ? `${bundleId}:lead` : bundleId } : {};
              return { id: item.variant.id, quantity: 1, properties };
            }),
          };
          if (cart) {
            body.sections = cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
            cart.setActiveElement(document.activeElement);
          }

          const error = this.querySelector('[data-bundle-error]');
          error.hidden = true;
          this.button.disabled = true;
          this.button.classList.add('loading');
          this.button.querySelector('.loading__spinner')?.classList.remove('hidden');

          try {
            const response = await fetch(window.routes.cart_add_url, {
              ...fetchConfig('javascript'),
              body: JSON.stringify(body),
            }).then((res) => res.json());

            if (response.status) {
              error.textContent = response.description || response.message;
              error.hidden = false;
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'uv-bundle', cartData: response });
            }
            cart.renderContents({ ...response.items[0], sections: response.sections });
            cart.classList.remove('is-empty');
          } catch (e) {
            console.error(e);
          } finally {
            this.button.classList.remove('loading');
            this.button.querySelector('.loading__spinner')?.classList.add('hidden');
            this.update();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uv-icon-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uv-icon-product')) {
    customElements.define(
      'uv-icon-product',
      class UvIconProduct extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.idInput = this.form.querySelector('[name="id"]');
          this.label = this.querySelector('[data-uv-label]');
          this.button = this.querySelector('[name="add"]');
          this.variants = JSON.parse(this.querySelector('[data-uv-variants]').textContent);
          this.addEventListener('change', (event) => {
            if (event.target instanceof HTMLInputElement && event.target.type === 'radio') {
              this.onOptionChange();
            }
          });
          this.initThumbs();

          const current = this.variants.find((item) => String(item.id) === this.idInput.value);
          const startIndex = current ? this.slideForVariant(current) : -1;
          if (startIndex > 0) {
            this.gallery.scrollLeft = this.slideOffset(startIndex);
            this.setActiveThumb(startIndex);
          }
        }

        slideForVariant(variant) {
          if (!variant.mediaId) return -1;
          return this.slides.findIndex((slide) => slide.id.endsWith(`-${variant.mediaId}`));
        }

        initThumbs() {
          this.gallery = this.querySelector('.uv-gallery');
          this.slides = Array.from(this.gallery.children);
          this.thumbs = Array.from(this.querySelectorAll('[data-uv-thumb]'));
          if (this.thumbs.length === 0) return;

          this.currentSlide = 0;
          this.querySelector('.uv-thumbs').addEventListener('click', (event) => {
            const thumb = event.target.closest('[data-uv-thumb]');
            if (thumb) this.showSlide(Number(thumb.dataset.uvThumb));
          });

          let frame;
          this.gallery.addEventListener(
            'scroll',
            () => {
              cancelAnimationFrame(frame);
              frame = requestAnimationFrame(() => {
                if (this.scrollTarget !== undefined) return;
                this.setActiveThumb(this.visibleSlide());
              });
            },
            { passive: true }
          );
        }

        slideOffset(index) {
          return this.slides[index].offsetLeft - this.slides[0].offsetLeft;
        }

        visibleSlide() {
          const left = this.gallery.scrollLeft;
          let closest = 0;
          this.slides.forEach((slide, index) => {
            if (Math.abs(this.slideOffset(index) - left) < Math.abs(this.slideOffset(closest) - left)) {
              closest = index;
            }
          });
          return closest;
        }

        showSlide(index) {
          const count = this.slides.length;
          const target = (index + count) % count;
          this.scrollTarget = target;
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => {
            this.scrollTarget = undefined;
          }, 700);
          this.gallery.scrollTo({ left: this.slideOffset(target), behavior: 'smooth' });
          this.setActiveThumb(target);
        }

        setActiveThumb(index) {
          if (this.thumbs.length === 0) return;
          if (index === this.currentSlide && this.thumbs[index].classList.contains('is-active')) return;
          this.currentSlide = index;
          this.thumbs.forEach((thumb, thumbIndex) => {
            const active = thumbIndex === index;
            thumb.classList.toggle('is-active', active);
            if (active) {
              thumb.setAttribute('aria-current', 'true');
            } else {
              thumb.removeAttribute('aria-current');
            }
          });
          const thumb = this.thumbs[index];
          const track = thumb.parentElement;
          track.scrollTo({
            top: thumb.offsetTop - (track.clientHeight - thumb.offsetHeight) / 2,
            behavior: 'smooth',
          });
        }

        onOptionChange() {
          const selected = Array.from(this.querySelectorAll('fieldset')).map((fieldset) => {
            return fieldset.querySelector('input[type="radio"]:checked')?.value;
          });
          const variant = this.variants.find((item) => {
            return item.options.every((option, index) => option === selected[index]);
          });
          if (!variant) return;

          this.idInput.value = variant.id;
          this.idInput.disabled = !variant.available;
          this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
          this.button.disabled = !variant.available;
          this.label.textContent = variant.available
            ? this.dataset.addLabel.replace('__PRICE__', variant.price)
            : this.dataset.soldOut;

          const slideIndex = this.slideForVariant(variant);
          if (slideIndex >= 0) this.showSlide(slideIndex);

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);

          document.dispatchEvent(
            new CustomEvent('harmony:variant-change', {
              detail: { productId: Number(this.dataset.productId), variantId: variant.id, options: variant.options },
            })
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
